import Button from './Button';
import styles from './parts.module.css';

export const LoadingState = ({ label }) => (
    <div className={styles.state} role="status" aria-busy="true">
        <span className={styles.sr}>Loading {label}</span>
        <span aria-hidden="true">Loading…</span>
    </div>
);

export const EmptyState = ({ children }) => <p className={styles.state}>{children}</p>;

export const ErrorState = ({ label, status, onRetry }) => (
    <div className={styles.stateError} role="alert">
        {status === 403 ? (
            <span>You don't have access to this.</span>
        ) : (
            <>
                <span>Couldn't load {label}.</span>
                <Button onClick={onRetry}>Retry</Button>
            </>
        )}
    </div>
);
